import { css, keyframes } from '../customEmotion';

const loadingCircle = keyframes`
	100% {
		transform: rotate(360deg);
	}
`;

export const spin = css`
  animation: ${loadingCircle} 1s linear infinite;
`;
